import React, { useEffect, useState } from "react";
import { fetchCreditHistory, formatMoney } from "../../services/clientPaymentService";
import styles from "./CreditHistoryList.module.scss";

// Self-contained - fetches and renders its own data given just a clientId,
// so it can be dropped into a page section (Customer.js) or a Dialog
// (AdminPaymentHistory.js's client credit tab) with no extra wiring.
// Callers that need to force a refresh (e.g. right after granting credit)
// should remount it via a bumped `key` prop rather than adding a refresh
// prop here - matches the pattern already used for GrantCreditDialog.
const CreditHistoryList = ({ clientId }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        fetchCreditHistory(clientId).then((res) => {
            if (cancelled) return;
            setHistory(res?.success ? res.data : []);
            setLoading(false);
        });
        return () => {
            cancelled = true;
        };
    }, [clientId]);

    if (loading) {
        return <p className={styles.empty}>Loading...</p>;
    }
    if (history.length === 0) {
        return <p className={styles.empty}>No credit adjustments recorded for this account.</p>;
    }

    return (
        <div className={styles.list}>
            {history.map((entry) => (
                <div className={styles.row} key={entry._id}>
                    <div className={styles.main}>
                        <span className={entry.amount >= 0 ? styles.amountPositive : styles.amountNegative}>
                            {entry.amount >= 0 ? "+" : "-"}
                            {formatMoney(Math.abs(entry.amount))}
                        </span>
                        <span className={styles.date}>{new Date(entry.createdAt).toLocaleString()}</span>
                    </div>
                    <p className={styles.reason}>{entry.reason}</p>
                    <p className={styles.meta}>
                        {formatMoney(entry.balanceBefore)} &rarr; {formatMoney(entry.balanceAfter)}
                        {entry.linkedInvoiceId ? ` · Invoice #${entry.linkedInvoiceId}` : ""}
                        {entry.replacementInvoiceId ? ` · Reopened as #${entry.replacementInvoiceId}` : ""}
                        {` · ${entry.recordedByName || "-"}`}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default CreditHistoryList;
